import React from 'react'
import { Link } from 'react-router-dom'
const Failure = () => {
  return (
    <div className='faildiv'>
      <img src={require('./images/cancel.png')}/>
      <p>Payment Failed!</p>
      <Link to="/cart"><button>Back to Cart</button></Link>
    </div>
  )
}

export default Failure
